import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  RemoveTag: 'Remove tag',
});

class Tag extends React.PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    item: PropTypes.shape({
      value: PropTypes.object.isRequired,
    }),
    title: PropTypes.string,
    removeTitle: PropTypes.string,
    onRemove: PropTypes.func,
  };

  static defaultProps = {
    onRemove: () => {},
    item: undefined,
    title: null,
    removeTitle: null,
  };

  onRemove = e => {
    const { onRemove, item } = this.props;

    e.preventDefault();
    e.stopPropagation();
    if (onRemove) {
      onRemove({ ...item });
    }
  };

  render() {
    const { intl, item, title, removeTitle } = this.props;
    return (
      <span className="document-tag" title={title}>
        {item.name}
        <i
          className="fa fa-times margin5L"
          aria-hidden="true"
          onClick={this.onRemove}
          title={removeTitle || intl.formatMessage(messages.RemoveTag)}
        />
        {/* <span
          style={{ marginLeft: '3px' }}
          className="pointer"
          onClick={this.onRemove}
          title={removeTitle || intl.formatMessage(messages.RemoveTag)}
        >
          x
        </span> */}
      </span>
    );
  }
}

export default injectIntl(Tag);
